import React from 'react';
import { Divider } from '@paypalcorp/pp-react';

export default function PayPalDivider() {
  return <Divider />;
}
